import { connect } from 'react-redux'
import SettingsModal from './SettingsModal'
import { hideSettingsModal } from '../../dataStore/actions/ui/uiActions'
import { State } from '../../dataStore/reducers/reducerType'
import { setSettings } from '../../dataStore/actions/room/room'
import { SettingsModalProps, SettingsTabs } from './types'
import selectIsLocalParticipantDialedIn from '../../dataStore/selectors/selectIsLocalParticipantDialedIn'
import selectPresenterBackground from '../../dataStore/selectors/selectPresenterBackground'

const getPresenterBackground = selectPresenterBackground()


const mapStateToProps = (state: State): Omit<SettingsModalProps, 'onConfirm' | 'onCancel'> => ({
  audioSource: state.tracks.audioSource,
  selectedWebcamDeviceId: state.tracks.selectedVideoDeviceID,
  selectedMicrophoneDeviceId: state.tracks.selectedAudioDeviceID,
  isDialInConnected: selectIsLocalParticipantDialedIn(state),
  background: getPresenterBackground(state),
  selectedTab: state.ui.settingsModalTab || SettingsTabs.DeviceSettings

})

const mapDispatchToProps = dispatch => ({
  onConfirm: (settings) => dispatch(setSettings(settings)),
  onCancel: () => dispatch(hideSettingsModal())
})

export default connect(mapStateToProps, mapDispatchToProps)(SettingsModal)